import Video from './videos'
export default Video
